module.exports = "<ngx-loading-bar height=\"8px\" color=\"red\" includeSpinner=\"false\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n"